import {
  createCampaignAdGroupSelector,
} from '@bingads-webui-campaign-react/campaign-adgroup-selector-control';
import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { TargetingSettingsContext } from './targeting-settings-context';

export class CampaignAdgroupSelectorVnext extends DeterministicWrapperView {
  viewFactory({
    scope,
    level,
    campaignId,
    i18n,
    selectedCampaign,
    selectedAdGroup,
    optionalCampaignFilter,
    optionalAdgroupFilter,
    optionalCampaignSelect,
    optionalAdGroupSelect,
    optionalAdGroupExpand,
  }) {
    const { edmCampaign, jsDataCampaign: jsData } = TargetingSettingsContext;

    this.campaignAdgroupSelector = createCampaignAdGroupSelector({
      jsData,
      edmCampaign,
      scope,
      level,
      campaignId,
      i18n,
      selectedCampaign,
      selectedAdGroup,
      parentView: this,
      optionalCampaignFilter,
      optionalAdgroupFilter,
      optionalCampaignSelect,
      optionalAdGroupSelect,
      optionalAdGroupExpand,
    });
    return this.campaignAdgroupSelector;
  }
}
